import { DateFilterComponent } from './date-filter.component';
import { DateHeaderColumn } from './date-header-column';
import { ItemDateFilter } from './item-date-filter';
import { FormFieldHeader } from '../../common/register/form-field-header/form-field-header';

export class DateHeader extends FormFieldHeader {
  constructor(item) {
    super(item);

    this.columns = [];

    if (item.isSingleDate === false) {
      this.columns.push(new DateHeaderColumn(item, { start: true, dateRange: true }));
      this.columns.push(new DateHeaderColumn(item, { end: true, dateRange: true }));
    } else {
      this.columns.push(new DateHeaderColumn(item));
    }

    const [start, end] = this.columns.map((column) => column.filter);

    this.filter = this.static ? start : new ItemDateFilter(start, end, DateFilterComponent);
  }
}
